const PIPELINE_STEPS = {
    DATASET: 'dataset',
    MERGE: 'merge',

    // Table Actions
    ADD_COLUMN: 'add-column',

    // Column Actions
    EDIT_COLUMN: 'edit-column',
    HIDE_COLUMN: 'hide-column',
    RENAME_COLUMN: 'rename-column',
    SORT_COLUMN: 'sort-column',
};

export default PIPELINE_STEPS;
